<!-- @format -->

<template>
	<div class="comment" :class="{ reply: props.reply }">
		<div class="comment-sub">
			<el-avatar :size="40" style="margin-top: 5px" fit="cover">
				<el-icon :size="25"> <UserFilled /> </el-icon>
			</el-avatar>
		</div>
		<div class="comment-primary">
			<div class="comment-main">
				<div class="user-info">
					<div class="username">
						<span class="name" style="max-width: 10em">{{ data.user.username }}</span>
					</div>
					<time class="time">{{ data.createTime }}</time>
				</div>
				<div class="content">
					<div v-html="contents"></div>
				</div>
				<div class="action-box select-none">
					<!-- 回复 -->
					<div v-if="!disabledReply" ref="btnRef" class="item" :class="{ active: state.active }" @click="replyClick">
						<el-icon>
							<svg
								viewBox="0 0 1024 1024"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								p-id="1320"
								width="200"
								height="200"
							>
								<path
									d="M147.264 647.296V220.928c0-49.536 40.128-89.728 89.6-89.728H793.6c49.536 0 89.728 40.192 89.728 89.728v426.368c0 49.536-40.128 89.728-89.6 89.728h-145.216a47.04 47.04 0 0 0-28.16 9.408l-194.56 145.792a3.392 3.392 0 0 1-5.12-1.984l-26.752-116.672a47.04 47.04 0 0 0-45.824-36.544H236.992a89.728 89.728 0 0 1-89.728-89.728zM236.864 64A156.928 156.928 0 0 0 80 220.928l0.064 426.368a156.928 156.928 0 0 0 156.928 156.928h94.976l23.232 101.312 0.064 0.448a70.592 70.592 0 0 0 109.696 40.832l190.208-142.592H793.6a156.928 156.928 0 0 0 156.928-156.928l-0.064-426.368A156.928 156.928 0 0 0 793.536 64H236.928z m69.44 442.496a65.344 65.344 0 1 0 0-130.752 65.344 65.344 0 0 0 0 130.752z m268.8-65.344a65.344 65.344 0 1 1-130.752 0 65.344 65.344 0 0 1 130.752 0z m138.368 65.344a65.344 65.344 0 1 0 0-130.752 65.344 65.344 0 0 0 0 130.752z"
									p-id="1321"
								></path>
							</svg>
						</el-icon>
						<span>{{ state.active ? '取消回复' : '回复' }}</span>
					</div>
				</div>
				<div v-if="state.active">
					<InputBox
						ref="commentRef"
						:parent-id="str(id)"
						:placeholder="`回复 @${data.user.username}...`"
						:reply="data"
						content-btn="发布"
						style="margin-top: 12px"
						:disabled-input="disabledReply"
						@hide="hide"
						@close="state.active = false"
					/>
				</div>
			</div>
			<!-- 回复列表 -->
			<slot></slot>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { str } from '../utils';
	import InputBox from './input-box.vue';

	interface Props {
		reply?: boolean;
		data: any;
		id: string;
		disabledReply: boolean;
	}

	const props = defineProps<Props>();

	const state = reactive({
		active: false,
	});

	const commentRef = ref<any>();
	const btnRef = ref<HTMLDivElement>();

	//点击回复按钮打开输入框
	function replyClick() {
		state.active = !state.active;
		if (state.active) {
			nextTick(() => {
				commentRef.value?.focus();
			});
		}
	}

	// 提交评论关闭输入框
	function hide(event: Event) {
		const target = event.target as HTMLElement;

		if (!btnRef.value?.contains(target)) {
			state.active = false;
		}
	}

	const contents = computed(() => props.data.content);
</script>

<style lang="scss" scoped>
	.comment {
		display: flex;

		a:hover {
			text-decoration: none;
		}

		.u-icon {
			font-size: 16px;
		}

		&-primary {
			flex: 1;
			margin-left: 16px;
			overflow: hidden;
		}
	}

	.comment-main {
		.user-info {
			display: flex;
			align-items: center;

			.username {
				display: flex;
				align-items: center;

				.name {
					max-width: 10px;
					font-weight: 500;
					color: #303133;
					line-height: 32px;
					margin-right: 4px;
				}
			}

			.time {
				margin-left: auto;
				line-height: 22px;
				color: #8a919f;
			}
		}
	}

	.action-box {
		display: flex;
		align-items: center;
		position: relative;

		.item {
			margin-right: 16px;
			line-height: 20px;
			line-height: 22px;
			cursor: pointer;
			color: #909399;

			.el-icon {
				margin-right: 4px;
			}

			span {
				vertical-align: text-bottom;
			}
		}

		.item:hover,
		.active {
			color: var(--el-color-primary);
		}
	}

	.u-fold {
		margin-top: 8px;
	}

	.reply {
		padding: 0;

		.content-box {
			margin-left: 12px;
		}

		.el-avatar {
			--el-avatar-size: 24px !important;
		}
	}

	.reply:not(:first-child) {
		margin-top: 10px;
	}
</style>
